import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export function exportToExcel(optionFiltro) {
    
  if (!optionFiltro || optionFiltro.length === 0) {
    console.error("Nenhum dado disponível para exportar.");
    return;
  }

  const data = optionFiltro?.map((item) => ({
    "Número NCE": item.ID_NCE,
    "Status": item.ETAPA_DESCRICAO,
    "Data": item.DATA_ABERTURA,
    "Unidade do Solicitante": item.GP_UNIDADE,
    "Unidade do Fornecedor": item.FOR_UNIDADE,
    "Fornecedor": item.FORNECEDOR,
    "Material": item.EMBALAGEM,
    "Tipo de Defeito": item.TIPO_DE_DEFEITO ?? '-',
    "Causa da Ocorrência": item.CAUSA_DA_OCORRENCIA ?? '-',
    "Ação": item.ACAO ?? '-',
    "Tipo da Ação": item.TIPO ?? '-'
  }));


  const worksheet = XLSX.utils.json_to_sheet(data);

  // Personalize a largura das colunas (em caracteres)
  worksheet["!cols"] = [
    { wch: 15 }, // Número NCE
    { wch: 15 }, // Status
    { wch: 12 }, // Data
    { wch: 25 }, // Unidade do Solicitante
    { wch: 25 }, // Unidade do Fornecedor
    { wch: 30 }, // Fornecedor
    { wch: 20 }, // Material
    { wch: 25 }, // Tipo de Defeito
    { wch: 30 }, // Causa da Ocorrência
    { wch: 30 }, // Ação
    { wch: 20 } // Tipo da Ação
  ];


  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "NCEs");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(blob, "nces.xlsx");
}